import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { GridComponent, GridDataResult } from '@progress/kendo-angular-grid';
import { PtKendoGridDirective } from '../../../../_foundation/kendo/directives/pt-kendo-grid/pt-kendo-grid.directive';
import { AppConfig } from '../../../../app/app.config';
import { KendoGridColumnConfig, KendoGridDataConfig } from '../../../../_foundation/kendo/models/grid.models';
import { State } from '@progress/kendo-data-query';
import { ProjectDetailService } from '../../../../services/setup/project-detail.service';
import locationGridConfig from './project-detail-location-grid.config';
import { ProjectDetailCoaGridPage } from '../project-detail-coa-grid/project-detail-coa-grid';

@IonicPage()
@Component({
  selector: 'page-project-detail-location-grid',
  templateUrl: 'project-detail-location-grid.html',
})
export class ProjectDetailLocationGridPage {
  @ViewChild('grid') grid?: GridComponent;
  @ViewChild('ptKendoGrid') ptKendoGrid: PtKendoGridDirective;

  projectId: number;
  projectName: string;
  stageId: number;
  stageName: string;

  config = AppConfig.settings;
  loading: boolean = false;
  gridConfig: KendoGridColumnConfig = locationGridConfig;
  gridData: GridDataResult;
  gridDataConfig: KendoGridDataConfig;

  public state: State = {
    take: 15,
    sort: locationGridConfig.defaultSort,
  };

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              private projectDetailService: ProjectDetailService) {
    this.projectId = this.navParams.get('projectId');
    this.projectName = this.navParams.get('projectName');
    this.stageId = this.navParams.get('stageId');
    this.stageName = this.navParams.get('stageName');

    this.gridDataConfig = this.projectDetailService.getLocationGridDataConfig(this.stageId);
  }

  ionViewDidLoad() {
    this.loadGrid();
  }

  private loadGrid(): void {
    if (this.ptKendoGrid) {
      this.ptKendoGrid.updateGrid().subscribe(res => {
        this.gridData = res;
      });
    }
  }

  viewCoaGrid(row: any) {
    this.navCtrl.push(ProjectDetailCoaGridPage, {
      projectId: this.projectId,
      projectName: this.projectName,
      locationId: row.id,
      locationName: row.name});
  }
}



// WEBPACK FOOTER //
// ./src/pages/setup/project-details/project-detail-location-grid/project-detail-location-grid.ts